module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-EVA_1.d7ab641e.jpg";